import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { Automation } from '@vendasta/automata';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { MatRadioModule } from '@angular/material/radio';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GalaxyPipesModule } from '@vendasta/galaxy/pipes';

interface DialogData {
  builtInAutomation: Automation;
}

@Component({
  template: `
    <mat-dialog-content>
      <h2 mat-dialog-title>
        {{ 'AUTOMATIONS.UNPUBLISH_BUILT_IN_AUTOMATION_DIALOG.TITLE' | translate: { name: builtInAutomation.name } }}
      </h2>
      <div class="dialog-content">
        <span
          [innerHTML]="'AUTOMATIONS.UNPUBLISH_BUILT_IN_AUTOMATION_DIALOG.DESCRIPTION' | translate | iTrustThisHtml"
        ></span>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions>
      <button mat-button color="primary" mat-dialog-close>{{ 'AUTOMATIONS.COMMON.CANCEL' | translate }}</button>
      <button mat-raised-button mat-button color="primary" (click)="continue()">
        {{ 'AUTOMATIONS.UNPUBLISH_BUILT_IN_AUTOMATION_DIALOG.UNPUBLISH' | translate }}
      </button>
    </mat-dialog-actions>
  `,
  styleUrls: ['./unpublish-built-in-automation-dialog.component.scss'],
  imports: [
    CommonModule,
    TranslateModule,
    MatDialogModule,
    GalaxyAlertModule,
    MatRadioModule,
    MatFormFieldModule,
    MatButtonModule,
    FormsModule,
    ReactiveFormsModule,
    GalaxyPipesModule,
  ],
})
export class UnpublishBuiltInAutomationDialogComponent {
  builtInAutomation: Automation;

  constructor(
    public dialogRef: MatDialogRef<UnpublishBuiltInAutomationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
  ) {
    this.builtInAutomation = this.data.builtInAutomation;
  }

  continue(): void {
    this.dialogRef.close({
      automationId: this.builtInAutomation.id,
    });
  }
}
